<template>
  <div>
    <div v-if='serverUpdate' class="serverUpdate">
        <div class="tips-warn flx-row-bw-c">
          <span>
              <span style="color:#F85A36;">温馨提示：</span>
              有1家{{ serverUpdate.type === 1 ? '注册局' :'站点'}}计划进行例行维护，请留意维护时间。如有不便，敬请谅解。
          </span>
          <div class="check-detail" @click="showServerUpdate = true">
            查看详情
          </div>
        </div>
    </div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">域名状态：</div>
          <div class="bj-rows">
            <div
              :class="[
                'item-radio',
                { active: item.value === searchObj.domainStatus },
              ]"
              v-for="item in domainStatusList"
              :key="item.value"
              @click="onCheckDomainStatus(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px">
        <div class="item">
          <div class="name" style="margin-right: 10px">交易状态：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="searchObj.bargainStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in bargainStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">实名认证：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="searchObj.approvedStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in approvedStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="name" style="margin-right: 10px">自动续费：</div>
          <Select
              class="bj-select-h45 bj-bg-color-26262A"
              v-model="searchObj.isAutoRenew"
              style="width: 180px"
              clearable
          >
            <Option
                v-for="item in isAutoRenewList"
                :value="item.value"
                :key="item.value"
            >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px">
        <div class="item" style="margin-right: 100px">
          <div class="name" style="margin-right: 10px">注册 / 转入时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            :value="registeredAtArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onRegisteredChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-right: 60px">
          <div class="name" style="margin-right: 10px">过期时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            :value="expiredStartTimeArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onExpiredTimeChange"
          ></DatePicker>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px">
        <div class="item">
          <div class="name" style="margin-right: 10px">域名包含：</div>
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="searchObj.name"
            placeholder="域名包含"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="item" style="margin: 0 20px">
          <div class="name" style="margin-right: 10px">域名后缀：</div>
          <Select
              class="bj-select-h45 bj-bg-color-26262A"
              v-model="searchObj.domainSuffix"
              style="width: 180px"
              clearable
          >
            <Option
                v-for="item in domainQueryData.domainSuffix"
                :value="item.domainSufName"
                :key="item.domainSufName"
            >{{ item.domainSufName }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-right: 100px">
          <div class="name" style="margin-right: 10px">模板：</div>
          <Button
              class="bj-search-btn-F85A36"
              type="primary"
              @click="showCheckedTemplate"
          >{{ !templateInfo.id ? "选择模板" : templateInfo.name }}</Button
          >
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px">
        <div style="margin-left: 20px" class="item">
          <Button
              class="bj-search-btn-F85A36"
              type="primary"
              style="margin-right: 20px"
              @click="onSearch"
          >
            搜索</Button
          >
          <Button class="bj-border-F85A36" @click="onSearchCancel">
            重置</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <Table
        class="bj-2F3033-table"
        stripe
        ref="domianTable"
        :loading="tableLoading"
        :columns="columns"
        :data="data"
        @on-selection-change="goodsSelectFn"
        @on-select-cancel="selectCancel"
      >
        <template slot="action" slot-scope="{ row }">
          <div v-if="row" class="bj-rows">
            <div class="table-btn" @click="onToolClick(row, 3)">域名详情</div>
            <div
              v-if="row.status != 5 || row.status != 6"
              class="table-btn"
              @click="onToolClick(row, 0)"
            >
              续费
            </div>
<!--            <div
              v-if="row.status != 5 || row.status != 6"
              class="table-btn"
              @click="onToolClick(row, 1)"
            >
              解析
            </div>-->
            <div
              v-if="row.status != 5 || row.status != 6"
              class="table-btn"
              @click="onToolClick(row, 2)"
            >
              DNS
            </div>
            <Dropdown
              placement="bottom"
              :transfer="true"
              @on-click="($event) => dropdownEvent($event, row)"
            >
              <a style="color: #3676f8" href="javascript:void(0)"
                >更多<Icon type="ios-arrow-down"></Icon
              ></a>
              <DropdownMenu slot="list">
                <DropdownItem :disabled="row.dnsPlatformNum === 1" :name="3"
                  >PUSH</DropdownItem
                >
                <DropdownItem :disabled="row.dnsPlatformNum === 1" :name="4"
                  >模板过户</DropdownItem
                >
                <!-- <DropdownItem :name="6">域名详情</DropdownItem> -->
                <DropdownItem v-if="row.status === 5" :name="7"
                  >赎回</DropdownItem
                >
                <DropdownItem
                  v-if="row.status === 6"
                  :disabled="row.status === 5 || row.status === 6"
                  :name="8"
                  >赎回中</DropdownItem
                >
                <DropdownItem
                  v-if="
                    row.status !== 2 &&
                    row.status !== 5 &&
                    row.status !== 6 &&
                    row.auto === 0
                  "
                  :name="9"
                  >设置自动续费</DropdownItem
                >
                <DropdownItem v-if="row.auto === 1" :name="10"
                  >取消自动续费</DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
        <template slot="isExternal" slot-scope="{ row }">
          {{ row.isExternal === 0 ? "内部" : "外部" }}
        </template>
        <template slot="approvedStatus" slot-scope="{ row }">
          {{ row.approvedStatus | approvedStatus }}
        </template>
      </Table>
      <div class="page-tool">
        <div style="display: flex">
          <Button class="bj-search-btn-F85A36" @click="handleSelectAll">{{
            !selectAll ? "全选" : "取消全选"
          }}</Button>
          <Select
            class="bj-select-h45 bj-bg-color-26262A"
            v-model="actionId"
            style="
              width: 140px;
              margin-right: 10px;
              margin-left: 10px;
              text-align: left;
            "
            @on-change="batchChange"
          >
            <Option
              v-for="item in actionList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
          <Button
            style="margin-right: 10px"
            class="bj-search-btn-F85A36"
            type="primary"
            @click="batchEvent"
            >批量管理</Button
          >
        </div>
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
          show-total
        />
      </div>
    </div>
    <templateListModal
      :show.sync="templateListModalVisibility"
      :id="templateInfo.id"
      @onChecked="checkedTemplate"
    ></templateListModal>
    <renewListModal
      :show.sync="renewModalVisibility"
      :title="renewModalTitle"
      :data="renewList"
    ></renewListModal>
    <DNSListModal
      :show.sync="DNSListModalVisibility"
      :data="DNSData"
      @submit-success="onSuccess"
    ></DNSListModal>
    <domainDetailModal
      :show.sync="domainDetailModalVisibility"
      :data="domainDetailData"
    ></domainDetailModal>
    <autoRenewModal
      :show.sync="autoRenewModalVisibility"
      @confirm="autoRenewcConfirm"
    ></autoRenewModal>
    <!-- 例行维护公告 -->
    <Modal
      v-model="showServerUpdate"
      sticky
      :width="650"
      footer-hide
      title="例行维护公告"
    >
      <div v-if='serverUpdate' class="serverUpdate-wrap">
        <div class="serverUpdate-content">{{ serverUpdate.content }}</div>
        <div class="serverUpdate-info">
          <div class="serverUpdate-time">{{ serverUpdate.startTime }} - {{ serverUpdate.endTime }}</div>
          <div class="serverUpdate-item">维护机构：{{ serverUpdate.type === 1 ? 'CNNIC网关' :'站点'}}</div>
          <div class="serverUpdate-item">维护时间：{{ serverUpdate.startTime }} - {{ serverUpdate.endTime }}</div>
          <div class="serverUpdate-item" v-if='serverUpdate.type === 1'>影响域名：<span v-for="(item,index) in serverUpdate.suffix" :key="item">{{ item }}{{index === serverUpdate.suffix.length-1 ? '' : '/'}}</span></div>
          <div class="serverUpdate-item">影响操作：新注、续费、转入、赎回、实名认证等服务</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import {
  domainList,
  addShopCart,
  domainSetPrivacy,
  domainAutoRenew,
  serverUpdate
} from "api/domain.js";
import templateListModal from "components/template/templateListModal.vue";
import renewListModal from "components/domain/renewListModal.vue";
import DNSListModal from "components/domain/DNSListModal.vue";
import domainDetailModal from "components/domain/domainDetailModal.vue";
import autoRenewModal from "components/domain/autoRenewModal.vue";

export default {
  name: "domain",
  filters: {
    approvedStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未认证";
          break;
        case 1:
          title = "认证中(审核中)";
          break;
        case 2:
          title = "认证成功(审核通过)";
          break;
        case 3:
          title = "认证失败(审核未通过)";
          break;
      }
      return title;
    },
  },
  components: {
    templateListModal,
    renewListModal,
    DNSListModal,
    domainDetailModal,
    autoRenewModal,
  },
  data() {
    return {
      tableLoading: false,
      searchObj: {
        domainStatus: -1,
        bargainStatus: -1,
        approvedStatus: -1,
        // 域名品类(一级)
        domainType: "",
        // 域名构成(二级)
        domainConstruction: "",
        // 自动续费
        isAutoRenew: "",
        // 域名后缀
        domainSuffix: "",
        // 注册/转入结束时间
        endedTime: "",
        // 注册/转入开始时间
        registeredAt: "",
        // 过期时间
        expiredStartTime: "",
        expiredEndTime: "",
        // 域名长度
        startExtent: "",
        endExtent: "",
        name: "",
        rule: [],
        page: 1,
        limit: 10,
        total: 0,
      },
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "30天内到期",
          value: 0,
        },
        {
          name: "已过期",
          value: 1,
        },
        {
          name: "赎回期",
          value: 2,
        },
      ],
      // 交易状态
      bargainStatusList: [
        {
          name: "正在push",
          value: 1,
        },
        {
          name: "正在转出",
          value: 3,
        },
      ],
      // 实名认证
      approvedStatusList: [
        {
          name: "未认证",
          value: 0,
        },
        {
          name: "认证中(审核中)",
          value: 1,
        },
        {
          name: "认证成功(审核通过)",
          value: 2,
        },
        {
          name: "认证失败(审核未通过)",
          value: 3,
        },
      ],
      domainTypeStr: [],
      isAutoRenewList: [
        {
          name: "否",
          value: 0,
        },
        {
          name: "是",
          value: 1,
        },
      ],
      // 转入时间
      registeredAtArr: [],
      expiredStartTimeArr: [],
      // 全选
      all: false,
      //表格数据
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 60,
          align: "center",
        },
        {
          key: "dn",
          title: "域名",
          align: "center",
        },
        {
          key: "regT",
          title: "注册时间",
          align: "center",
        },
        {
          key: "expT",
          title: "过期时间",
          align: "center",
        },
        // {
        //   width: 100,
        //   slot: "isExternal",
        //   title: "注册商",
        //   align: "center",
        // },
        {
          key: "temp",
          title: "模板",
          align: "center",
        },
        {
          slot: "cerStatus",
          title: "命名认证",
          align: "center",
          render: (h, params) => {
            return h("span", this.getAuthStatusText(params.row.cerStatus));
          },
        },
        {
          width: 300,
          slot: "action",
          title: "操作",
          align: "center",
        },
      ],
      data: [],
      actionId: null,
      // 操作选项
      actionList: [
        {
          value: 1,
          label: "批量续费",
        },
        {
          value: 2,
          label: "设置自动续费",
        },
        {
          value: 3,
          label: "取消自动续费",
        },
        // {
        //   value: 4,
        //   label: "设置DNS",
        // },
        {
          value: 5,
          label: "开启隐私保护",
        },
        {
          value: 6,
          label: "关闭隐私保护",
        },
        // {
        //   value: 7,
        //   label: "批量出售",
        // },
        {
          value: 8,
          label: "批量PUSH",
        },
      ],
      templateListModalVisibility: false, // 选择模板
      templateInfo: {},
      renewModalVisibility: false, // 续费
      renewList: [],
      renewModalTitle: "",
      checkedDomain: [],
      value: [],
      selectAll: false,
      DNSListModalVisibility: false, // DNS
      DNSData: {},
      domainDetailModalVisibility: false, // 域名详情
      domainDetailData: {},
      autoRenewModalVisibility: false, // 续费弹窗
      serverUpdate:null,
      showServerUpdate:false
    };
  },
  computed: {
    ...mapState(["domainQueryData"]),
  },
  watch: {
    checkedDomain: {
      immediate: true,
      handler(val) {
        this.value = val;
      },
    },
  },
  created() {
    if (
      this.domainQueryData.domainTypeList.length === 0 ||
      this.domainQueryData.domainSufNameList.length === 0
    ) {
      this.ACT_DOMAIN_QUERY();
    }
    this.getServerUpdate();
    this.req_getList();
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    ...mapMutations(["MTU_ROUTE_PARAMS_LIST"]),
    getAuthStatusText(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未认证";
          break;
        case 1:
          title = "认证中";
          break;
        case 2:
          title = "认证成功";
          break;
        case 3:
          title = "认证失败";
          break;
        default:
          title = "-";
          break;
      }
      return title;
    },
    // 获取例行维护公告
    async getServerUpdate() {
      const { code, data } = await serverUpdate();
      if (code == 200) {
        this.serverUpdate = data
      }
    },
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.searchObj.domainStatus !== -1 &&
          (params.exType = this.searchObj.domainStatus);
        this.searchObj.bargainStatus !== -1 &&
          (params.state = this.searchObj.bargainStatus);
        this.searchObj.approvedStatus !== -1 &&
          (params.rz = this.searchObj.approvedStatus);
        this.searchObj.domainType &&
          (params.category = this.searchObj.domainType);
        this.searchObj.domainConstruction &&
          (params.structure = this.searchObj.domainConstruction);
        this.searchObj.isAutoRenew &&
          (params.autoRenew = this.searchObj.isAutoRenew);
        this.searchObj.domainSuffix &&
          (params.suffix = this.searchObj.domainSuffix);
        this.searchObj.registeredAt &&
          (params.transferInTime = this.searchObj.registeredAt);
        this.searchObj.endedTime &&
          (params.transferOutTime = this.searchObj.endedTime);
        this.searchObj.expiredStartTime &&
          (params.strExTime = this.searchObj.expiredStartTime);
        this.searchObj.expiredEndTime &&
          (params.endExTime = this.searchObj.expiredEndTime);
        this.searchObj.startExtent &&
          (params.startLen = this.searchObj.startExtent);
        this.searchObj.endExtent && (params.endLen = this.searchObj.endExtent);
        this.searchObj.name && (params.dn = this.searchObj.name);
        this.searchObj.rule.length > 0 &&
          (params.begAndEnd = this.searchObj.rule[0]);
        this.templateInfo.id && (params.templateId = this.templateInfo.id);
        this.tableLoading = true;
        const { code, data } = await domainList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            let isCheckEd = false;
            if (this.checkedDomain.length > 0) {
              isCheckEd = this.checkedDomain.some((v) => {
                return v === o.dn;
              });
            }
            return { ...o, _checked: isCheckEd, _disabled: false };
          });
          this.data = array;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 域名转台改变
    onCheckDomainStatus(val) {
      this.searchObj.domainStatus = val;
      this.onPageChange(1);
    },
    // 日期改变
    onRegisteredChange(event) {
      this.searchObj.registeredAt = event[0];
      this.searchObj.endedTime = event[1];
    },
    // 日期改变
    onExpiredTimeChange(event) {
      this.searchObj.expiredStartTime = event[0];
      this.searchObj.expiredEndTime = event[1];
    },
    // 级联选择器选择变化
    cascaderChange(value) {
      let temp = value[1].split("_");
      this.searchObj.domainType = temp[0];
      this.searchObj.domainConstruction = temp[1];
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.templateInfo = {};
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val) {
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    //全选
    handleSelectAll() {
      if (!this.actionId) {
        this.$Message.warning("请先选择批量操作类型！");
        return false;
      }
      this.selectAll =
        this.data.filter((o) => !o._disabled).length !==
        this.data.filter((o) => o._checked).length;
      // 设置选中状态
      this.$nextTick(() => {
        this.data.forEach((o) => {
          o._checked = this.selectAll;
        });
        this.$refs.domianTable.selectAll(this.selectAll);
      });
    },
    // 批量类型事件
    batchChange(value) {
      this.data.forEach((o) => {
        let _disabled = false;
        if (value === 1 || value === 4 || value === 7 || value === 8) {
          // 批量续费  设置DNS 批量出售 批量PUSH // schedule域名状态  isAutoRenew是否自动续费  certificationStatus认证状态 isShowUser隐私保护
          o._disabled = o.status === 5 || o.status === 6;
          value === 7 && o.cerStatus !== 2 && (o._disabled = true);
          value === 8 && o.state !== 0 && (o._disabled = true);
        } else if (value === 2) {
          // 自动续费
          o._disabled =
            o.status === 2 || o.status === 5 || o.status === 6 || o.auto === 1;
        } else if (value === 2) {
          // 取消自动续费
          o._disabled = o.auto !== 1;
        } else if (value === 5) {
          // 设置隐私保护
          o._disabled = o.protect === 0;
        } else if (value === 6) {
          // 取消隐私保护
          o._disabled = o.protect === 1;
        }
        if (this.selectAll) {
          o._checked = !o._disabled;
        }
        return { ...o, _disabled };
      });
      if (this.selectAll) {
        this.value = this.data
          .filter((o) => o._checked)
          .map((o) => {
            return { name: o.dn, did: o.id };
          });
        this.value.length === 0 && (this.selectAll = false);
      }
    },
    goodsSelectFn(item) {
      /*if (item.length > 0) {
        let obj = {};
        item.forEach((o) => {
          !o._disabled && (obj[o.did] = true);
        });
        // 设置选中状态
        this.data.forEach((o) => {
          if (obj[o.did]) {
            o._checked = true;
          } else {
            o._checked = false;
          }
        });
        // 组合所有数据
        obj = {};
        let newArray = [
          ...this.value,
          ...(this.data.filter((o) => o._checked) || []),
        ];
        // 取数据的并集
        this.value = newArray.reduce((item, next) => {
          if (!obj[next.did]) {
            obj[next.did] = true;
            item.push({ ...next, _checked: true });
          }
          return item;
        }, []);
      } else {
        let obj = {};
        // 排除取消选中的数据
        this.data.forEach((o) => {
          !o._disabled && (obj[o.did] = true);
        });
        this.value = this.value.reduce((item, next) => {
          !obj[next.did] && item.push({ ...next, _checked: true });
          return item;
        }, []);
      }*/
      this.value = item
    },
    selectCancel(selection, row) {
      console.log(row)
      let index = this.value.findIndex((item) => {
        return item.id === row.id;
      });
      this.value.splice(index, 1);
    },

    // 全选
    // allSelect(event, val) {
    //   this.data.forEach((o, index) => {
    //     !o._disabled && (o._checked = val);
    //     this.$set(this.data, index, o);
    //   });
    //   // 单页全选
    //   if (val) {
    //     this.value = this.data.filter(o => o._checked).map((o) => {
    //       return {name: o.name, did: o.did};
    //     });
    //   } else {
    //     this.value = [];
    //   }
    // },
    // 选中
    // select() {
    //   let row = arguments[1];
    //   if (!row._disabled) {
    //     let index = this.data.findIndex((o) => o.name === row.name);
    //     row._checked = true;
    //     // 对比数据中有没有选中的数据
    //     !this.value.some((o) => o.name === row.name) && this.value.push({name: row.name, did: row.did});
    //     this.$set(this.data, index, row);
    //   }
    // },
    // 取消选中
    // selectCancel() {
    //   let row = arguments[1];
    //   let index = this.data.findIndex((o) => o.name === row.name);
    //   row._checked = false;
    //   // 查找下标
    //   let cindex = this.value.findIndex((o) => o.name === row.name);
    //   cindex !== -1 && this.value.splice(cindex, 1);
    //   this.$set(this.data, index, row);
    // },
    // 更多操作
    dropdownEvent(type, data) {
      if (type === 3) {
        // PUSH
        if (data.state != 0) {
          let title = "";
          switch (data.state) {
            case 1:
              title = "域名正在出售中!";
              break;
            case 2:
              title = "域名正在PUSH中!";
              break;
            case 3:
              title = "域名正在转出中!";
              break;
            case 4:
              title = "域名正在预删除中!";
              break;
          }
          this.$Message.warning(title);
          return false;
        }
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST([data.dn]);
        this.$router.push({
          path: "/my/push",
        });
      } else if (type === 4) {
        // 模板过户
        if (data.state !== 0) {
          let title = "";
          switch (data.state) {
            case 1:
              title = "域名正在出售中!";
              break;
            case 2:
              title = "域名正在PUSH中!";
              break;
            case 3:
              title = "域名正在转出中!";
              break;
            case 4:
              title = "域名正在预删除中!";
              break;
          }
          this.$Message.warning(title);
          return false;
        }
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST([data.dn]);
        this.$router.push({
          path: "/my/template/transfer",
        });
      } else if (type === 6) {
        // 域名详情
        this.domainDetailModalVisibility = true;
        this.domainDetailData = { ...data };
      } else if (type === 9 || type === 10) {
        // 设置自动续费 OR 取消自动续费
        this.autoRenewType = type === 9 ? 0 : 1;
        this.autoRenewIds = [data.dn];
        this.autoRenewModalVisibility = true;
      }
    },
    // 续费
    async req_renew(val) {
      try {
        let params = {
          domains: val,
          type: 1,
        };
        const { code, data, result } = await addShopCart(params);
        if (code === 200 && result && data.length === 0) {
          this.$Message.success("添加成功！");
          setTimeout(() => {
            window.location.href = "/cart";
          }, 1000);
        } else {
          this.renewModalVisibility = true;
          this.renewModalTitle = "域名续费结果";
          this.renewList = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 操作按钮事件
    onToolClick(val, type = 0) {
      if (type === 0 && val.status !== 5 && val.status !== 6) {
        // 续费
        this.req_renew([val.dn]);
      } else if (type === 1 && val.status !== 5 && val.status !== 6) {
        // 解析
        if (val.dnsPlatformNum === 1) {
          this.$Message.warning("第三方DNS，禁止在本平台解析!");
          return false;
        }
        this.$router.push({
          name: `domainAnalysis`,
          query: {
            id: val.id,
            domainName: val.dn,
          },
        });
      } else if (type === 2 && val.status !== 5 && val.status !== 6) {
        // DNS
        this.$router.push({
          path: "/my/domain/dns",
          query: { id: val.id, name: val.dn },
        });
      } else if (type === 3) {
        // 域名详情
        this.domainDetailModalVisibility = true;
        this.domainDetailData = val;
      }
    },
    // 点击批量操作
    batchEvent() {
      if (!this.actionId) {
        this.$Message.warning("请选择操作类型!");
        return false;
      }
      if (this.value.length <= 0) {
        this.$Message.warning("请选择要操作的数据!");
        return false;
      }

      if (this.actionId === 1) {
        //批量续费
        this.req_renew(
          this.value.map((o) => {
            return o.dn;
          })
        );
      } else if (this.actionId === 8) {
        //批量PUSH
        // 传递参数
        this.MTU_ROUTE_PARAMS_LIST(
          this.value.map((o) => {
            return o.dn;
          })
        );
        this.$router.push({
          path: "/my/push",
        });
      } else if (this.actionId === 5 || this.actionId === 6) {
        this.privacyIds = this.value.map((o) => {
          return o.id;
        });
        this.$Modal.confirm({
          title: `${this.actionId === 5 ? "开启隐私保护" : "关闭隐私保护"}`,
          content: `${
            this.actionId === 5 ? "是否开启隐私保护?" : "是否关闭隐私保护?"
          }`,
          onOk: async () => {
            try {
              const { code, data } = await domainSetPrivacy({
                ids: this.privacyIds,
                hide: this.actionId === 5 ? 1 : 0,
              });
              if (code === 200) {
                if (data.length === 0) {
                  this.$Message.success("操作成功！");
                } else {
                  this.renewModalTitle =
                    this.actionId === 5
                      ? "开启隐私保护结果"
                      : "关闭隐私保护结果";
                  this.renewModalVisibility = true;
                  this.renewList = data.map((o) => {
                    return {
                      dn: o.ym,
                      msg: o.reason,
                      status: o.status,
                    };
                  });
                }
              }
              this.req_getList();
            } catch (error) {
              console.log(error);
            }
          },
        });
      } else if (this.actionId === 2 || this.actionId === 3) {
        this.autoRenewType = this.actionId === 2 ? 0 : 1;
        this.autoRenewIds = this.value.map((o) => {
          return o.did;
        });
        this.autoRenewModalVisibility = true;
      }
      // else if (this.batchValue === 21 || this.batchValue === 22) {
      //   //设置自动续费
      //   this.domainIdList = selectList.map((o) => {
      //     return o.domainId;
      //   });
      //   this.autoRenewType = this.batchValue === 21 ? 0 : 1;
      //   // 打开短信验证码模态框
      //   this.autoRenewModalShow = true;
      //   // this.batchAutoRenew(data, 0);
      // } else if (this.batchValue === 23) {
      //   // 批量设置DNS
      //   this.settingsDNSModalShow = true;
      //   this.domainIds = selectList.map((o) => {
      //     return o.id;
      //   });
      // } else if (this.batchValue === 24 || this.batchValue === 25) {
      //   this.privacyIds = selectList.map((o) => {
      //     return o.id;
      //   });
      //   this.$Modal.confirm({
      //     title: `${this.batchValue === 24 ? '开启隐私保护' : '关闭隐私保护'}`,
      //     content: `${this.batchValue === 24 ? '是否开启隐私保护?' : '是否关闭隐私保护?'}`,
      //     onOk: async () => {
      //       const { code, data } = await this.$API.bidding.setPrivacy({
      //         domainIds: this.privacyIds,
      //         isHide: this.batchValue === 24 ? 0 : 1
      //       });
      //       if (code === 200) {
      //         if (data.length === 0) {
      //           this.$Message.success('操作成功！');
      //         } else {
      //           this.autoRenewModalTitle = this.batchValue === 24 ? '开启隐私保护结果' : '关闭隐私保护结果';
      //           this.autoRenewModalShow = true;
      //           this.autoRenewrenewList = data;
      //         }
      //       }
      //       this.getDomainPageList();
      //     }
      //   });
      // } else if (this.batchValue === 26) {
      //   const data = selectList.map((o) => {
      //     return o.domainName;
      //   });
      //   this.$router.push({
      //     name: 'user-dnSell',
      //     params: { dnList: data }
      //   });
      // } else if (this.batchValue === 27) {
      //   const data = value.map((o) => {
      //     return o.domainName;
      //   });
      //   this.$router.push({
      //     name: 'user-dnPush',
      //     params: { dnList: data }
      //   });
      // }
      // this.$emit('batchEvent', this.batchValue, selectList);
    },
    async autoRenewcConfirm(val, callback) {
      try {
        this.tableLoading = true;
        const res = await domainAutoRenew({
          code: val,
          ids: this.autoRenewIds,
          type: this.autoRenewType,
        });
        if (res.code === 200) {
          if (res.data.length === 0) {
            this.$Message.success("操作成功！");
          } else {
            // this.autoRenewModalTitle = this.autoRenewType === 0 ? '设置自动续费结果' : '取消设置自动续费结果';
            // this.autoRenewModalShow = true;
            // this.autoRenewrenewList = res.data;
            this.renewModalVisibility = true;
            this.renewModalTitle =
              this.autoRenewType === 0
                ? "设置自动续费结果"
                : "取消设置自动续费结果";
            this.renewList = res.data.map((o) => {
              return {
                dn: o.ym,
                msg: o.reason,
                status: o.status,
              };
            });
          }
        }
        this.autoRenewModalVisibility = false;
        callback(true);
        this.req_getList();
        this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
        callback(true);
        console.log(error);
      }
    },
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
.tips-warn{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #38393B;
  color: #fff;
  line-height: 46px;
  padding: 0 24px;
  border-radius: 6px;
  margin-bottom: 30px;
  .check-detail{
      width:100px;
			background:#F85A36;
			text-align: center;
			color: #fff;
			height: 30px;
			line-height: 30px;
			border-radius: 5px;
			cursor: pointer;
      margin-left: 20px;
  }
}
.serverUpdate-wrap{
  padding: 20px;
  color: #333;
  .serverUpdate-info{
    margin-top: 20px;
    padding-top: 20px;
    border-top:1px solid #e8eaec;
    .serverUpdate-time{
      font-weight: bold;
      margin-bottom: 10px;
      position: relative;
      margin-left: 15px;
      &::before{
        position: absolute;
        top:8px;
        left:-15px;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #F85A36;
      }
    }
    .serverUpdate-item{
      margin: 5px 0 5px 15px;
    }
  }
}
.bj-search-section {
  background-color: #28292c;
  padding: 30px 28px;
  border-radius: 6px;
  .bj-search-row {
    display: flex;
    .item {
      display: flex;
      align-items: center;
      .name {
        color: #fff;
      }
    }
  }
}
.item-radio {
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  cursor: pointer;
  margin-right: 40px;
  border: 1px solid #fff;
  min-width: 100px;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  transition: all 0.3s;
}
.item-radio.active {
  color: #fff;
  background-color: #f85a36;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.pages {
  flex: 1;
}
</style>

